// src/pages/about.jsx
import React from "react";
import { Box, Typography, IconButton, Grid, Divider } from "@mui/material";
import { Instagram, LinkedIn, Email } from "@mui/icons-material";

const About = () => {
  return (
    <Box
      sx={{
        px: { xs: 4, md: 20 }, // horizontal padding
        py: { xs: 8, md: 10 }, // vertical padding
        bgcolor: "#fff",
      }}
    >
      {/* Top Section */}
      <Grid container spacing={6} alignItems="flex-start">
        {/* Left side - heading */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h3"
            sx={{
              fontFamily: "Playfair Display, serif",
              color: "#b89b6c",
              fontWeight: 600,
              fontSize: { xs: "2rem", md: "2.8rem" },
              lineHeight: 1.3,
            }}
          >
            About ARC Studioz
          </Typography>
        </Grid>

        {/* Right side - content */}
        <Grid item xs={12} md={8}>
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              color: "#333",
              lineHeight: 1.9,
              fontSize: "1rem", textAlign:"justify",
              mb: 3,
            }}
          >
            At ARC Studioz, every project begins with a story one shaped by
            thoughtful design, precise engineering, and a commitment to
            craftsmanship that defines who we are. As a contemporary
            design-and-build firm, we offer a cohesive spectrum of services
            across Architecture, Interior Design and Contracting. Ensuring that
            every space we create is a seamless integration of form and
            function.
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              color: "#333",
              lineHeight: 1.9,
              fontSize: "1rem", textAlign:"justify"
            }}
          >
            Our unified approach is our biggest strength. By bringing design
            and execution under one roof, we eliminate the disconnect that often
            exists between planning and construction. This allows us to preserve
            design intent, maintain transparency, and deliver spaces that are
            completed on time, on budget, and without compromise. From spatial
            analysis to the final finish, our attention to detail ensures that
            each project whether a bespoke residence or a dynamic commercial
            environment carries the unmistakable ARC Studioz signature.
          </Typography>
          <br />
          <Typography
            variant="body1"
            sx={{
              fontFamily: "Montserrat, sans-serif",
              color: "#333",
              lineHeight: 1.9,
              fontSize: "1rem", textAlign:"justify"
            }}
          >
            We are a true one-stop solution for all interior and architectural
            needs, including electrical, Lighting, Plumbing, HVAC & CCTV. Every
            element is managed with precision, allowing our clients to
            experience a smooth, cohesive journey from concept to completion.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;
